import _ from 'lodash';
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../actions/actions';

class Email extends React.Component {
    constructor(props) {
        super(props);
        this.inputValue = null;
        this.saveForm = this.saveForm.bind(this);
    }

    saveForm(e) {
        // TODO: promise
        e.preventDefault();
        this.props.actions.setAppEmail(this.inputValue);
        this.props.actions.clientSend();
        this.props.buttonSecondary();
        this.props.actions.setActivePage(_.last(this.props.pagesList));
    }

    render() {
        const { buttonSecondary } = this.props;

        return (
            <div>
                <header className="modal-header">
                    <h3>Please add your email</h3>
                </header>
                <form onSubmit={this.saveForm}>
                    <div className="modal-body">
                        <div className="input">
                            <div className="input__field">
                                <input type="email" id="name" placeholder="Type your email ..." onChange={(e) => { this.inputValue = e.target.value; }} required />
                            </div>
                        </div>
                    </div>
                    <div className="modal-buttons">
                        <a className="modal-buttons__button cancel-button" onClick={buttonSecondary}>Cancel</a>
                        <button type="submit" className="modal-buttons__button confirm-button">Save</button>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    modal: state.modal,
    pagesList: state.pages.list,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Email.propTypes = {
    app: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
    pagesList: PropTypes.array.isRequired,
    buttonSecondary: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Email);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Email.jsx